export const DESTROY_SESSION = "DESTROY_SESSION";

export const USER_PROFILE = "USER_PROFILE";
export const REVIEWS_LIST = "REVIEWS_LIST";
export const OPTION_LIST = "OPTION_LIST";
export const ORDER_HISTORY = "ORDER_HISTORY";
export const USER_ADDRESSES = "USER_ADDRESSES";
export const SALES_ORDER = "SALES_ORDER";
